import { Button, Spinner } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Icon } from "@lomarengas/design-system";
import BookingRowsTable from "./BookingRowsTable";
import {
  getAllBookings,
  selectAllBookingsStatus,
  selectBookingItemsAll,
} from "./bookingsSlice";
import { LOADING_STATUS } from "../../common/constants";

const AllBookings = () => {
  const dispatch = useAppDispatch();
  const [allBookingsToLoad, setAllBookingsToLoad] = useState(false);

  const bookingItemsAll = useAppSelector((state) =>
    selectBookingItemsAll(state),
  );
  const allBookingsStatus = useAppSelector((state) =>
    selectAllBookingsStatus(state),
  );
  const initFetch = () => {
    if (!allBookingsToLoad) {
      return;
    }
    // Fetch all bookings of every accommodation of this owner, without the seven day limit
    dispatch(getAllBookings());
  };
  useEffect(() => {
    initFetch();
  }, [allBookingsToLoad]);

  return (
    <>
      <Button
        onClick={() => setAllBookingsToLoad(!allBookingsToLoad)}
        aria-expanded={allBookingsToLoad}
        variant="outline-blue"
        className="w-100 mt-16"
      >
        <Icon Name="chevron-expand" /> Näytä kaikki alkavat varaukset
      </Button>

      {allBookingsToLoad && (
        <>
          {allBookingsStatus === LOADING_STATUS.LOADING ? (
            <div className="d-flex gap-16 align-items-center mt-16">
              <Spinner animation="border" />
              <span>Ladataan varauksia…</span>
            </div>
          ) : allBookingsStatus === LOADING_STATUS.IDLE &&
            bookingItemsAll != null &&
            bookingItemsAll.length > 0 ? (
            <BookingRowsTable
              bookings={bookingItemsAll}
              clearAllPastBookings={true}
              showCottageName={true}
              onICalSaved={() => dispatch(getAllBookings())}
            />
          ) : (
            <p className="mt-16">Ei varauksia.</p>
          )}
        </>
      )}
    </>
  );
};

export default AllBookings;
